"use strict";
//import { api_prefix } from "./index";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_API_PATH = exports.AuthPath = void 0;
const auth = "/auth";
exports.AuthPath = {
    auth,
};
const api_prefix = "api";
const handlePath = ({ path }) => {
    const apiPath = {
        frontend: `${api_prefix}${auth}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.AUTH_API_PATH = {
    signUp: handlePath({
        path: `signup`,
    }),
    login: handlePath({
        path: `login`,
    }),
    authByCookie: handlePath({
        path: `cookie_auth`,
    }),
    logout: handlePath({
        path: `logout`,
    }),
    optCodeByClientId: handlePath({
        path: `opt_by_client`,
    }),
    optRequest: handlePath({
        path: `opt_request`,
    }),
    optConfirmation: handlePath({
        path: `opt_confirmation`,
    }),
};
//# sourceMappingURL=auth.js.map